import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

/**
 * @deprecated
 */
export default {
  namespaced: true,
  state: {
    connected: {
      with_fee: [],
      without_fee: []
    },
    fetchingConnected: false
  },
  mutations: {
    setConnected (state, connected) {
      state.connected = connected
    }
  },
  actions: {
    fetchConnected ({ state, commit }, domain) {
      state.fetchingConnected = true

      apiService.getProjectServices(domain, 1)
        .then(response => {
          commit('setConnected', response.data.services)

          state.fetchingConnected = false
        })
        .catch(() => {
          state.fetchingConnected = false

          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить информацию по услугам.'
          })
        })
    }
  },
  getters: {
    isConnected: state => serviceName => {
      return !!(state.connected.with_fee.find((service) => service.symbol_name === serviceName) ||
        state.connected.without_fee.find((service) => service.symbol_name === serviceName))
    }
  }
}
